let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8Kivm"), load("8eNS3"), load("kSBog"), load("jwSno"), load("iQ0Jm"), load("2eiOk")]).then(() => parcelRequire('do0K0'));